import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import type { PropType } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  props: {
    cancelCallback: {
      type: Function as PropType<() => void>,
    },
    okCallback: {
      type: Function as PropType<(closeCallback?: () => void) => void>,
      required: true,
    },
    cancelButtonText: {
      type: String,
      required: true,
    },
    okButtonText: {
      type: String,
      default: 'OK',
    },
    confirmationText: {
      type: String,
      required: true,
    },
    showSvgs: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const isConfirmingAction = ref(false)
  const { closeIcon, checkmark } = useIcons()

  const okAction = () => {
    isConfirmingAction.value = true
    props.okCallback(() => {
      emit('close')
    })
  }

  const cancelAction = () => {
    if (typeof props.cancelCallback === 'function') props.cancelCallback()
    emit('close')
  }

return { __sfc: true,props, emit, isConfirmingAction, closeIcon, checkmark, okAction, cancelAction, ref, KetchUpButton, LoadingSpinner, SVGRenderer, useIcons }
}

})